import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import UserManagement from "./components/UserManagement";
import InviteUser from "./components/InviteUser";
import SamConfig from "./components/SamConfig";
import IngestStatus from "./components/IngestStatus";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { cn } from "../../lib/utils";
import { Users, UserPlus, Settings, Database, Activity } from "lucide-react";

export default function AdminDashboard() {
  const { isSuperAdmin } = useAuth();
  const [activeTab, setActiveTab] = useState("users");

  const tabs = [
    { id: "users", label: "Users", icon: Users },
    { id: "invites", label: "Invitations", icon: UserPlus },
    { id: "sam", label: "SAM.gov Config", icon: Database },
    { id: "ingest", label: "Ingest Status", icon: Activity },
    { id: "settings", label: "Settings", icon: Settings },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Admin</h1>
        <p className="text-muted-foreground">
          System administration and configuration
        </p>
      </div>

      <div className="flex gap-2 border-b overflow-x-auto">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <Button
              key={tab.id}
              variant="ghost"
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                "rounded-none border-b-2 border-transparent shrink-0",
                activeTab === tab.id && "border-primary"
              )}
            >
              <Icon className="h-4 w-4 mr-2" />
              {tab.label}
            </Button>
          );
        })}
      </div>

      {activeTab === "users" && <UserManagement />}

      {activeTab === "invites" && <InviteUser />}

      {activeTab === "sam" && <SamConfig />}

      {activeTab === "ingest" && <IngestStatus />}

      {activeTab === "settings" && (
        <div className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>System Settings</CardTitle>
              <CardDescription>
                General application configuration
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <h3 className="font-medium">Application Settings</h3>
                <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1">
                  <li>Data retention policies</li>
                  <li>Notification preferences</li>
                  <li>Integration settings</li>
                </ul>
                <p className="text-sm text-muted-foreground mt-4">
                  Additional settings will be available in future releases.
                </p>
              </div>
            </CardContent>
          </Card>

          {isSuperAdmin && (
            <Card>
              <CardHeader>
                <CardTitle>Super Admin Settings</CardTitle>
                <CardDescription>
                  Advanced configuration options for super administrators
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Advanced system configuration will appear here.
                </p>
              </CardContent>
            </Card>
          )}
        </div>
      )}
    </div>
  );
}
